// This file is AUTOGENERATED, do not edit it manually!!!

import { projectFinancials as projectFinancialsde } from './projectFinancialsResx.de';
import { projectFinancials as projectFinancialsen } from './projectFinancialsResx.en';
import { projectFinancials as projectFinancialsen_risk } from './projectFinancialsResx.en_risk';
import { projectFinancials as projectFinancialses } from './projectFinancialsResx.es';
import { projectFinancials as projectFinancialsfr } from './projectFinancialsResx.fr';
import { projectFinancials as projectFinancialsit } from './projectFinancialsResx.it';
import { projectFinancials as projectFinancialsnl } from './projectFinancialsResx.nl';
import { projectFinancials as projectFinancialspl } from './projectFinancialsResx.pl';
import { projectFinancials as projectFinancialspt } from './projectFinancialsResx.pt';
import { projectFinancials as projectFinancialsru } from './projectFinancialsResx.ru';
import { projectFinancials as projectFinancialssk } from './projectFinancialsResx.sk';
import { projectFinancials as projectFinancialssv } from './projectFinancialsResx.sv';
import { projectFinancials as projectFinancialstr } from './projectFinancialsResx.tr';

const langMap: { [k: string]: Partial<typeof projectFinancialsen> } = {
    de: projectFinancialsde,
    en: projectFinancialsen,
    en_risk: projectFinancialsen_risk,
    es: projectFinancialses,
    fr: projectFinancialsfr,
    it: projectFinancialsit,
    nl: projectFinancialsnl,
    pl: projectFinancialspl,
    pt: projectFinancialspt,
    ru: projectFinancialsru,
    sk: projectFinancialssk,
    sv: projectFinancialssv,
    tr: projectFinancialstr,
};

/* tslint:disable: max-line-length */
export const projectFinancialsResx = {
    get actual_billing() {
        return langMap[ep.resxCulture].actual_billing || langMap.en.actual_billing;
    },
    get actual_cost() {
        return langMap[ep.resxCulture].actual_cost || langMap.en.actual_cost;
    },
    get ActualBillableExpenses() {
        return langMap[ep.resxCulture].ActualBillableExpenses || langMap.en.ActualBillableExpenses;
    },
    get ActualBillableExpensesShort() {
        return langMap[ep.resxCulture].ActualBillableExpensesShort || langMap.en.ActualBillableExpensesShort;
    },
    get ActualBilledShort() {
        return langMap[ep.resxCulture].ActualBilledShort || langMap.en.ActualBilledShort;
    },
    get ActualBillingShort() {
        return langMap[ep.resxCulture].ActualBillingShort || langMap.en.ActualBillingShort;
    },
    get ActualBudgetProfitability() {
        return langMap[ep.resxCulture].ActualBudgetProfitability || langMap.en.ActualBudgetProfitability;
    },
    get ActualCost() {
        return langMap[ep.resxCulture].ActualCost || langMap.en.ActualCost;
    },
    get ActualCostQtip() {
        return langMap[ep.resxCulture].ActualCostQtip || langMap.en.ActualCostQtip;
    },
    get ActualExpenses() {
        return langMap[ep.resxCulture].ActualExpenses || langMap.en.ActualExpenses;
    },
    get ActualExpensesListTitle() {
        return langMap[ep.resxCulture].ActualExpensesListTitle || langMap.en.ActualExpensesListTitle;
    },
    get ActualExpensesShort() {
        return langMap[ep.resxCulture].ActualExpensesShort || langMap.en.ActualExpensesShort;
    },
    get ActualHours() {
        return langMap[ep.resxCulture].ActualHours || langMap.en.ActualHours;
    },
    get ActualLaborBilling() {
        return langMap[ep.resxCulture].ActualLaborBilling || langMap.en.ActualLaborBilling;
    },
    get ActualLaborBillingShort() {
        return langMap[ep.resxCulture].ActualLaborBillingShort || langMap.en.ActualLaborBillingShort;
    },
    get ActualLaborCost() {
        return langMap[ep.resxCulture].ActualLaborCost || langMap.en.ActualLaborCost;
    },
    get ActualLaborCostShort() {
        return langMap[ep.resxCulture].ActualLaborCostShort || langMap.en.ActualLaborCostShort;
    },
    get add_activities_flat_fees() {
        return langMap[ep.resxCulture].add_activities_flat_fees || langMap.en.add_activities_flat_fees;
    },
    get add_as_actual_expense() {
        return langMap[ep.resxCulture].add_as_actual_expense || langMap.en.add_as_actual_expense;
    },
    get add_planned_billable_expenses() {
        return langMap[ep.resxCulture].add_planned_billable_expenses || langMap.en.add_planned_billable_expenses;
    },
    get add_received_payment() {
        return langMap[ep.resxCulture].add_received_payment || langMap.en.add_received_payment;
    },
    get add_scheduled_payment() {
        return langMap[ep.resxCulture].add_scheduled_payment || langMap.en.add_scheduled_payment;
    },
    get AddActivitiesBudgets() {
        return langMap[ep.resxCulture].AddActivitiesBudgets || langMap.en.AddActivitiesBudgets;
    },
    get AddBudgetLabel() {
        return langMap[ep.resxCulture].AddBudgetLabel || langMap.en.AddBudgetLabel;
    },
    get AddPlannedExpenses() {
        return langMap[ep.resxCulture].AddPlannedExpenses || langMap.en.AddPlannedExpenses;
    },
    get Amount() {
        return langMap[ep.resxCulture].Amount || langMap.en.Amount;
    },
    get approver_label() {
        return langMap[ep.resxCulture].approver_label || langMap.en.approver_label;
    },
    get approvers_problem_warning() {
        return langMap[ep.resxCulture].approvers_problem_warning || langMap.en.approvers_problem_warning;
    },
    get ApproveTooltip() {
        return langMap[ep.resxCulture].ApproveTooltip || langMap.en.ApproveTooltip;
    },
    get back_to_metrics() {
        return langMap[ep.resxCulture].back_to_metrics || langMap.en.back_to_metrics;
    },
    get batch_actual_text() {
        return langMap[ep.resxCulture].batch_actual_text || langMap.en.batch_actual_text;
    },
    get batch_approval_text() {
        return langMap[ep.resxCulture].batch_approval_text || langMap.en.batch_approval_text;
    },
    get batch_billed_text() {
        return langMap[ep.resxCulture].batch_billed_text || langMap.en.batch_billed_text;
    },
    get batch_operation_failed_description() {
        return langMap[ep.resxCulture].batch_operation_failed_description || langMap.en.batch_operation_failed_description;
    },
    get batch_operations_failed_description() {
        return langMap[ep.resxCulture].batch_operations_failed_description || langMap.en.batch_operations_failed_description;
    },
    get batch_reject_text() {
        return langMap[ep.resxCulture].batch_reject_text || langMap.en.batch_reject_text;
    },
    get Billable() {
        return langMap[ep.resxCulture].Billable || langMap.en.Billable;
    },
    get Billed() {
        return langMap[ep.resxCulture].Billed || langMap.en.Billed;
    },
    get BilledPercentQtip() {
        return langMap[ep.resxCulture].BilledPercentQtip || langMap.en.BilledPercentQtip;
    },
    get BilledVsActualCost() {
        return langMap[ep.resxCulture].BilledVsActualCost || langMap.en.BilledVsActualCost;
    },
    get Billing() {
        return langMap[ep.resxCulture].Billing || langMap.en.Billing;
    },
    get Billing_Info_Title() {
        return langMap[ep.resxCulture].Billing_Info_Title || langMap.en.Billing_Info_Title;
    },
    get billing_type_item_readonly() {
        return langMap[ep.resxCulture].billing_type_item_readonly || langMap.en.billing_type_item_readonly;
    },
    get BillingHelp() {
        return langMap[ep.resxCulture].BillingHelp || langMap.en.BillingHelp;
    },
    get BillingSettings() {
        return langMap[ep.resxCulture].BillingSettings || langMap.en.BillingSettings;
    },
    get BillingSettingsTitle() {
        return langMap[ep.resxCulture].BillingSettingsTitle || langMap.en.BillingSettingsTitle;
    },
    get BillingType() {
        return langMap[ep.resxCulture].BillingType || langMap.en.BillingType;
    },
    get BillingTypeLabel() {
        return langMap[ep.resxCulture].BillingTypeLabel || langMap.en.BillingTypeLabel;
    },
    get BillingUtilization() {
        return langMap[ep.resxCulture].BillingUtilization || langMap.en.BillingUtilization;
    },
    get BudgetedCost() {
        return langMap[ep.resxCulture].BudgetedCost || langMap.en.BudgetedCost;
    },
    get BudgetHelp() {
        return langMap[ep.resxCulture].BudgetHelp || langMap.en.BudgetHelp;
    },
    get CancelTooltip() {
        return langMap[ep.resxCulture].CancelTooltip || langMap.en.CancelTooltip;
    },
    get chart_actual_billing() {
        return langMap[ep.resxCulture].chart_actual_billing || langMap.en.chart_actual_billing;
    },
    get chart_actual_cost() {
        return langMap[ep.resxCulture].chart_actual_cost || langMap.en.chart_actual_cost;
    },
    get chart_billable_expenses() {
        return langMap[ep.resxCulture].chart_billable_expenses || langMap.en.chart_billable_expenses;
    },
    get chart_billed() {
        return langMap[ep.resxCulture].chart_billed || langMap.en.chart_billed;
    },
    get chart_billed_expenses() {
        return langMap[ep.resxCulture].chart_billed_expenses || langMap.en.chart_billed_expenses;
    },
    get chart_eac_billing() {
        return langMap[ep.resxCulture].chart_eac_billing || langMap.en.chart_eac_billing;
    },
    get chart_expenses() {
        return langMap[ep.resxCulture].chart_expenses || langMap.en.chart_expenses;
    },
    get chart_non_billable_expenses() {
        return langMap[ep.resxCulture].chart_non_billable_expenses || langMap.en.chart_non_billable_expenses;
    },
    get chart_payments() {
        return langMap[ep.resxCulture].chart_payments || langMap.en.chart_payments;
    },
    get chart_scheduled_payments() {
        return langMap[ep.resxCulture].chart_scheduled_payments || langMap.en.chart_scheduled_payments;
    },
    get ContingencyPadding() {
        return langMap[ep.resxCulture].ContingencyPadding || langMap.en.ContingencyPadding;
    },
    get Cost() {
        return langMap[ep.resxCulture].Cost || langMap.en.Cost;
    },
    get CPI() {
        return langMap[ep.resxCulture].CPI || langMap.en.CPI;
    },
    get CurrencyLabel() {
        return langMap[ep.resxCulture].CurrencyLabel || langMap.en.CurrencyLabel;
    },
    get CustomerHourlyRateLabel() {
        return langMap[ep.resxCulture].CustomerHourlyRateLabel || langMap.en.CustomerHourlyRateLabel;
    },
    get Date() {
        return langMap[ep.resxCulture].Date || langMap.en.Date;
    },
    get delete_the_expense_title() {
        return langMap[ep.resxCulture].delete_the_expense_title || langMap.en.delete_the_expense_title;
    },
    get delete_the_payment_title() {
        return langMap[ep.resxCulture].delete_the_payment_title || langMap.en.delete_the_payment_title;
    },
    get DeletePaymentConfirmation() {
        return langMap[ep.resxCulture].DeletePaymentConfirmation || langMap.en.DeletePaymentConfirmation;
    },
    get DeleteTooltip() {
        return langMap[ep.resxCulture].DeleteTooltip || langMap.en.DeleteTooltip;
    },
    get Description() {
        return langMap[ep.resxCulture].Description || langMap.en.Description;
    },
    get DetailedReportTitleTemplate() {
        return langMap[ep.resxCulture].DetailedReportTitleTemplate || langMap.en.DetailedReportTitleTemplate;
    },
    get EAC() {
        return langMap[ep.resxCulture].EAC || langMap.en.EAC;
    },
    get eac_billing() {
        return langMap[ep.resxCulture].eac_billing || langMap.en.eac_billing;
    },
    get eac_cost() {
        return langMap[ep.resxCulture].eac_cost || langMap.en.eac_cost;
    },
    get EACBilling() {
        return langMap[ep.resxCulture].EACBilling || langMap.en.EACBilling;
    },
    get EACBillingLong() {
        return langMap[ep.resxCulture].EACBillingLong || langMap.en.EACBillingLong;
    },
    get EACBillingQtip() {
        return langMap[ep.resxCulture].EACBillingQtip || langMap.en.EACBillingQtip;
    },
    get EACBillingQtipInfo() {
        return langMap[ep.resxCulture].EACBillingQtipInfo || langMap.en.EACBillingQtipInfo;
    },
    get EACCost() {
        return langMap[ep.resxCulture].EACCost || langMap.en.EACCost;
    },
    get EACCost_short() {
        return langMap[ep.resxCulture].EACCost_short || langMap.en.EACCost_short;
    },
    get EACCostQtip() {
        return langMap[ep.resxCulture].EACCostQtip || langMap.en.EACCostQtip;
    },
    get EnteredBy() {
        return langMap[ep.resxCulture].EnteredBy || langMap.en.EnteredBy;
    },
    get EstimatedBudgetProfitability() {
        return langMap[ep.resxCulture].EstimatedBudgetProfitability || langMap.en.EstimatedBudgetProfitability;
    },
    get EstimatedCostVariance() {
        return langMap[ep.resxCulture].EstimatedCostVariance || langMap.en.EstimatedCostVariance;
    },
    get EstimatedExpenses() {
        return langMap[ep.resxCulture].EstimatedExpenses || langMap.en.EstimatedExpenses;
    },
    get EstimatedHours() {
        return langMap[ep.resxCulture].EstimatedHours || langMap.en.EstimatedHours;
    },
    get EstimatedProfit() {
        return langMap[ep.resxCulture].EstimatedProfit || langMap.en.EstimatedProfit;
    },
    get EstimatedProfitPercentQtip() {
        return langMap[ep.resxCulture].EstimatedProfitPercentQtip || langMap.en.EstimatedProfitPercentQtip;
    },
    get EstimatedProfitQtip() {
        return langMap[ep.resxCulture].EstimatedProfitQtip || langMap.en.EstimatedProfitQtip;
    },
    get etc_billing() {
        return langMap[ep.resxCulture].etc_billing || langMap.en.etc_billing;
    },
    get etc_cost() {
        return langMap[ep.resxCulture].etc_cost || langMap.en.etc_cost;
    },
    get ETCBillableExpenses() {
        return langMap[ep.resxCulture].ETCBillableExpenses || langMap.en.ETCBillableExpenses;
    },
    get ETCBillableExpensesShort() {
        return langMap[ep.resxCulture].ETCBillableExpensesShort || langMap.en.ETCBillableExpensesShort;
    },
    get ETCBilling() {
        return langMap[ep.resxCulture].ETCBilling || langMap.en.ETCBilling;
    },
    get ETCBillingShort() {
        return langMap[ep.resxCulture].ETCBillingShort || langMap.en.ETCBillingShort;
    },
    get ETCCost() {
        return langMap[ep.resxCulture].ETCCost || langMap.en.ETCCost;
    },
    get ETCCostShort() {
        return langMap[ep.resxCulture].ETCCostShort || langMap.en.ETCCostShort;
    },
    get ETCCosttQtip() {
        return langMap[ep.resxCulture].ETCCosttQtip || langMap.en.ETCCosttQtip;
    },
    get ETCExpenses() {
        return langMap[ep.resxCulture].ETCExpenses || langMap.en.ETCExpenses;
    },
    get ETCExpensesShort() {
        return langMap[ep.resxCulture].ETCExpensesShort || langMap.en.ETCExpensesShort;
    },
    get ETCLaborBilling() {
        return langMap[ep.resxCulture].ETCLaborBilling || langMap.en.ETCLaborBilling;
    },
    get ETCLaborBillingShort() {
        return langMap[ep.resxCulture].ETCLaborBillingShort || langMap.en.ETCLaborBillingShort;
    },
    get ETCLaborCost() {
        return langMap[ep.resxCulture].ETCLaborCost || langMap.en.ETCLaborCost;
    },
    get ETCLaborCostShort() {
        return langMap[ep.resxCulture].ETCLaborCostShort || langMap.en.ETCLaborCostShort;
    },
    get ExpectedRevenue() {
        return langMap[ep.resxCulture].ExpectedRevenue || langMap.en.ExpectedRevenue;
    },
    get expenses() {
        return langMap[ep.resxCulture].expenses || langMap.en.expenses;
    },
    get expenses_approval_info() {
        return langMap[ep.resxCulture].expenses_approval_info || langMap.en.expenses_approval_info;
    },
    get expenses_approval_label() {
        return langMap[ep.resxCulture].expenses_approval_label || langMap.en.expenses_approval_label;
    },
    get expenses_approval_remove_all_approvers_title() {
        return langMap[ep.resxCulture].expenses_approval_remove_all_approvers_title || langMap.en.expenses_approval_remove_all_approvers_title;
    },
    get expenses_approval_status_approved() {
        return langMap[ep.resxCulture].expenses_approval_status_approved || langMap.en.expenses_approval_status_approved;
    },
    get expenses_approval_status_none() {
        return langMap[ep.resxCulture].expenses_approval_status_none || langMap.en.expenses_approval_status_none;
    },
    get expenses_approval_status_rejected() {
        return langMap[ep.resxCulture].expenses_approval_status_rejected || langMap.en.expenses_approval_status_rejected;
    },
    get expenses_approved_successfully_plural() {
        return langMap[ep.resxCulture].expenses_approved_successfully_plural || langMap.en.expenses_approved_successfully_plural;
    },
    get expenses_rejected_successfully_plural() {
        return langMap[ep.resxCulture].expenses_rejected_successfully_plural || langMap.en.expenses_rejected_successfully_plural;
    },
    get expenses_updated_successfully_plural() {
        return langMap[ep.resxCulture].expenses_updated_successfully_plural || langMap.en.expenses_updated_successfully_plural;
    },
    get FeeAmount() {
        return langMap[ep.resxCulture].FeeAmount || langMap.en.FeeAmount;
    },
    get FlatFee() {
        return langMap[ep.resxCulture].FlatFee || langMap.en.FlatFee;
    },
    get GeneralInfo() {
        return langMap[ep.resxCulture].GeneralInfo || langMap.en.GeneralInfo;
    },
    get HourlyRate() {
        return langMap[ep.resxCulture].HourlyRate || langMap.en.HourlyRate;
    },
    get InternalBudget() {
        return langMap[ep.resxCulture].InternalBudget || langMap.en.InternalBudget;
    },
    get InternalEstimatedCost() {
        return langMap[ep.resxCulture].InternalEstimatedCost || langMap.en.InternalEstimatedCost;
    },
    get LaborBilling() {
        return langMap[ep.resxCulture].LaborBilling || langMap.en.LaborBilling;
    },
    get LaborCost() {
        return langMap[ep.resxCulture].LaborCost || langMap.en.LaborCost;
    },
    get legend_actual() {
        return langMap[ep.resxCulture].legend_actual || langMap.en.legend_actual;
    },
    get legend_estimated_at_completion() {
        return langMap[ep.resxCulture].legend_estimated_at_completion || langMap.en.legend_estimated_at_completion;
    },
    get log_actual_expense() {
        return langMap[ep.resxCulture].log_actual_expense || langMap.en.log_actual_expense;
    },
    get log_expenses() {
        return langMap[ep.resxCulture].log_expenses || langMap.en.log_expenses;
    },
    get log_payments() {
        return langMap[ep.resxCulture].log_payments || langMap.en.log_payments;
    },
    get log_planned_expense() {
        return langMap[ep.resxCulture].log_planned_expense || langMap.en.log_planned_expense;
    },
    get money_for_date_label() {
        return langMap[ep.resxCulture].money_for_date_label || langMap.en.money_for_date_label;
    },
    get no_targets() {
        return langMap[ep.resxCulture].no_targets || langMap.en.no_targets;
    },
    get NoActualExpenses() {
        return langMap[ep.resxCulture].NoActualExpenses || langMap.en.NoActualExpenses;
    },
    get None() {
        return langMap[ep.resxCulture].None || langMap.en.None;
    },
    get NoneCurrency() {
        return langMap[ep.resxCulture].NoneCurrency || langMap.en.NoneCurrency;
    },
    get NoPayments() {
        return langMap[ep.resxCulture].NoPayments || langMap.en.NoPayments;
    },
    get NoPlannedExpenses() {
        return langMap[ep.resxCulture].NoPlannedExpenses || langMap.en.NoPlannedExpenses;
    },
    get NotBillable() {
        return langMap[ep.resxCulture].NotBillable || langMap.en.NotBillable;
    },
    get NotBillableLabel() {
        return langMap[ep.resxCulture].NotBillableLabel || langMap.en.NotBillableLabel;
    },
    get NotBilled() {
        return langMap[ep.resxCulture].NotBilled || langMap.en.NotBilled;
    },
    get OpenRateCard() {
        return langMap[ep.resxCulture].OpenRateCard || langMap.en.OpenRateCard;
    },
    get OutstandingPaymentBalance() {
        return langMap[ep.resxCulture].OutstandingPaymentBalance || langMap.en.OutstandingPaymentBalance;
    },
    get PaymentDescriptionWatermark() {
        return langMap[ep.resxCulture].PaymentDescriptionWatermark || langMap.en.PaymentDescriptionWatermark;
    },
    get PaymentReceived() {
        return langMap[ep.resxCulture].PaymentReceived || langMap.en.PaymentReceived;
    },
    get payments_total() {
        return langMap[ep.resxCulture].payments_total || langMap.en.payments_total;
    },
    get PaymentsOfSchedPayments() {
        return langMap[ep.resxCulture].PaymentsOfSchedPayments || langMap.en.PaymentsOfSchedPayments;
    },
    get PercentageBilled() {
        return langMap[ep.resxCulture].PercentageBilled || langMap.en.PercentageBilled;
    },
    get PercentageProjectBilled() {
        return langMap[ep.resxCulture].PercentageProjectBilled || langMap.en.PercentageProjectBilled;
    },
    get Percentages() {
        return langMap[ep.resxCulture].Percentages || langMap.en.Percentages;
    },
    get PlannedExpenses() {
        return langMap[ep.resxCulture].PlannedExpenses || langMap.en.PlannedExpenses;
    },
    get PlannedExpensesListTitle() {
        return langMap[ep.resxCulture].PlannedExpensesListTitle || langMap.en.PlannedExpensesListTitle;
    },
    get ppFormat() {
        return langMap[ep.resxCulture].ppFormat || langMap.en.ppFormat;
    },
    get Profit() {
        return langMap[ep.resxCulture].Profit || langMap.en.Profit;
    },
    get ProfitQtip() {
        return langMap[ep.resxCulture].ProfitQtip || langMap.en.ProfitQtip;
    },
    get Project_no_rateCard_for_rateCard_billingType() {
        return langMap[ep.resxCulture].Project_no_rateCard_for_rateCard_billingType || langMap.en.Project_no_rateCard_for_rateCard_billingType;
    },
    get ProjectActivityName() {
        return langMap[ep.resxCulture].ProjectActivityName || langMap.en.ProjectActivityName;
    },
    get ProjectBilling() {
        return langMap[ep.resxCulture].ProjectBilling || langMap.en.ProjectBilling;
    },
    get ProjectBillingIsBasedOn() {
        return langMap[ep.resxCulture].ProjectBillingIsBasedOn || langMap.en.ProjectBillingIsBasedOn;
    },
    get ProjectBillingUtilization() {
        return langMap[ep.resxCulture].ProjectBillingUtilization || langMap.en.ProjectBillingUtilization;
    },
    get ProjectBudget() {
        return langMap[ep.resxCulture].ProjectBudget || langMap.en.ProjectBudget;
    },
    get ProjectCost() {
        return langMap[ep.resxCulture].ProjectCost || langMap.en.ProjectCost;
    },
    get ProjectCostVariance() {
        return langMap[ep.resxCulture].ProjectCostVariance || langMap.en.ProjectCostVariance;
    },
    get ProjectEarnedValue() {
        return langMap[ep.resxCulture].ProjectEarnedValue || langMap.en.ProjectEarnedValue;
    },
    get ProjectEarnedValueInfo() {
        return langMap[ep.resxCulture].ProjectEarnedValueInfo || langMap.en.ProjectEarnedValueInfo;
    },
    get ProjectExpectedRevenue() {
        return langMap[ep.resxCulture].ProjectExpectedRevenue || langMap.en.ProjectExpectedRevenue;
    },
    get ProjectFixedCostLabel() {
        return langMap[ep.resxCulture].ProjectFixedCostLabel || langMap.en.ProjectFixedCostLabel;
    },
    get ProjectHourlyRateLabel() {
        return langMap[ep.resxCulture].ProjectHourlyRateLabel || langMap.en.ProjectHourlyRateLabel;
    },
    get ProjectPayments() {
        return langMap[ep.resxCulture].ProjectPayments || langMap.en.ProjectPayments;
    },
    get ProjectPlannedExpenses() {
        return langMap[ep.resxCulture].ProjectPlannedExpenses || langMap.en.ProjectPlannedExpenses;
    },
    get ProjectPlannedExpensesInfo() {
        return langMap[ep.resxCulture].ProjectPlannedExpensesInfo || langMap.en.ProjectPlannedExpensesInfo;
    },
    get ProjectProfit() {
        return langMap[ep.resxCulture].ProjectProfit || langMap.en.ProjectProfit;
    },
    get ProjectProfitability() {
        return langMap[ep.resxCulture].ProjectProfitability || langMap.en.ProjectProfitability;
    },
    get ProjectProfitabilityInfo() {
        return langMap[ep.resxCulture].ProjectProfitabilityInfo || langMap.en.ProjectProfitabilityInfo;
    },
    get ProjectTimeUsage() {
        return langMap[ep.resxCulture].ProjectTimeUsage || langMap.en.ProjectTimeUsage;
    },
    get ProjectTimeUsageInfo() {
        return langMap[ep.resxCulture].ProjectTimeUsageInfo || langMap.en.ProjectTimeUsageInfo;
    },
    get ProjectWorkInProgress() {
        return langMap[ep.resxCulture].ProjectWorkInProgress || langMap.en.ProjectWorkInProgress;
    },
    get PymentsVsActualCost() {
        return langMap[ep.resxCulture].PymentsVsActualCost || langMap.en.PymentsVsActualCost;
    },
    get RateCardLabel() {
        return langMap[ep.resxCulture].RateCardLabel || langMap.en.RateCardLabel;
    },
    get Receipt() {
        return langMap[ep.resxCulture].Receipt || langMap.en.Receipt;
    },
    get Received() {
        return langMap[ep.resxCulture].Received || langMap.en.Received;
    },
    get ReceivedPaymentsListTitle() {
        return langMap[ep.resxCulture].ReceivedPaymentsListTitle || langMap.en.ReceivedPaymentsListTitle;
    },
    get RemainingInternalBudget() {
        return langMap[ep.resxCulture].RemainingInternalBudget || langMap.en.RemainingInternalBudget;
    },
    get RemainingInternalBudgetQtip() {
        return langMap[ep.resxCulture].RemainingInternalBudgetQtip || langMap.en.RemainingInternalBudgetQtip;
    },
    get RemainingInternalBudgetQtipForProject() {
        return langMap[ep.resxCulture].RemainingInternalBudgetQtipForProject || langMap.en.RemainingInternalBudgetQtipForProject;
    },
    get ResourceHourlyRateLabel() {
        return langMap[ep.resxCulture].ResourceHourlyRateLabel || langMap.en.ResourceHourlyRateLabel;
    },
    get Revenue() {
        return langMap[ep.resxCulture].Revenue || langMap.en.Revenue;
    },
    get Scheduled() {
        return langMap[ep.resxCulture].Scheduled || langMap.en.Scheduled;
    },
    get ScheduledPaymentsListTitle() {
        return langMap[ep.resxCulture].ScheduledPaymentsListTitle || langMap.en.ScheduledPaymentsListTitle;
    },
    get set_targets() {
        return langMap[ep.resxCulture].set_targets || langMap.en.set_targets;
    },
    get Settings() {
        return langMap[ep.resxCulture].Settings || langMap.en.Settings;
    },
    get ShowAll() {
        return langMap[ep.resxCulture].ShowAll || langMap.en.ShowAll;
    },
    get ShowBreakdown() {
        return langMap[ep.resxCulture].ShowBreakdown || langMap.en.ShowBreakdown;
    },
    get ShowFull() {
        return langMap[ep.resxCulture].ShowFull || langMap.en.ShowFull;
    },
    get SPI() {
        return langMap[ep.resxCulture].SPI || langMap.en.SPI;
    },
    get status_label() {
        return langMap[ep.resxCulture].status_label || langMap.en.status_label;
    },
    get tab_Actual() {
        return langMap[ep.resxCulture].tab_Actual || langMap.en.tab_Actual;
    },
    get tab_expenses() {
        return langMap[ep.resxCulture].tab_expenses || langMap.en.tab_expenses;
    },
    get tab_overview() {
        return langMap[ep.resxCulture].tab_overview || langMap.en.tab_overview;
    },
    get tab_payments() {
        return langMap[ep.resxCulture].tab_payments || langMap.en.tab_payments;
    },
    get tab_Planned() {
        return langMap[ep.resxCulture].tab_Planned || langMap.en.tab_Planned;
    },
    get tab_Received() {
        return langMap[ep.resxCulture].tab_Received || langMap.en.tab_Received;
    },
    get tab_Scheduled() {
        return langMap[ep.resxCulture].tab_Scheduled || langMap.en.tab_Scheduled;
    },
    get tab_targets() {
        return langMap[ep.resxCulture].tab_targets || langMap.en.tab_targets;
    },
    get TargetBudget() {
        return langMap[ep.resxCulture].TargetBudget || langMap.en.TargetBudget;
    },
    get TargetLaborRevenue() {
        return langMap[ep.resxCulture].TargetLaborRevenue || langMap.en.TargetLaborRevenue;
    },
    get TargetProfit() {
        return langMap[ep.resxCulture].TargetProfit || langMap.en.TargetProfit;
    },
    get TargetRevenue() {
        return langMap[ep.resxCulture].TargetRevenue || langMap.en.TargetRevenue;
    },
    get Targets() {
        return langMap[ep.resxCulture].Targets || langMap.en.Targets;
    },
    get targets_tab() {
        return langMap[ep.resxCulture].targets_tab || langMap.en.targets_tab;
    },
    get TargetsEACBilling() {
        return langMap[ep.resxCulture].TargetsEACBilling || langMap.en.TargetsEACBilling;
    },
    get TaskRateLabel() {
        return langMap[ep.resxCulture].TaskRateLabel || langMap.en.TaskRateLabel;
    },
    get TimeAndMaterial() {
        return langMap[ep.resxCulture].TimeAndMaterial || langMap.en.TimeAndMaterial;
    },
    get TimeUsage() {
        return langMap[ep.resxCulture].TimeUsage || langMap.en.TimeUsage;
    },
    get TitleText() {
        return langMap[ep.resxCulture].TitleText || langMap.en.TitleText;
    },
    get total_billable() {
        return langMap[ep.resxCulture].total_billable || langMap.en.total_billable;
    },
    get TotalBilled() {
        return langMap[ep.resxCulture].TotalBilled || langMap.en.TotalBilled;
    },
    get TotalProjectBudget() {
        return langMap[ep.resxCulture].TotalProjectBudget || langMap.en.TotalProjectBudget;
    },
    get TotalProjectPayments() {
        return langMap[ep.resxCulture].TotalProjectPayments || langMap.en.TotalProjectPayments;
    },
    get TotalProjectPaymentsInfo() {
        return langMap[ep.resxCulture].TotalProjectPaymentsInfo || langMap.en.TotalProjectPaymentsInfo;
    },
    get TotalTargetRevenue() {
        return langMap[ep.resxCulture].TotalTargetRevenue || langMap.en.TotalTargetRevenue;
    },
    get TrackProfitAs() {
        return langMap[ep.resxCulture].TrackProfitAs || langMap.en.TrackProfitAs;
    },
    get Validation_DateMandatory() {
        return langMap[ep.resxCulture].Validation_DateMandatory || langMap.en.Validation_DateMandatory;
    },
    get Validation_InvalidAmount() {
        return langMap[ep.resxCulture].Validation_InvalidAmount || langMap.en.Validation_InvalidAmount;
    },
    get Validation_InvalidDate() {
        return langMap[ep.resxCulture].Validation_InvalidDate || langMap.en.Validation_InvalidDate;
    },
    get Validation_Range() {
        return langMap[ep.resxCulture].Validation_Range || langMap.en.Validation_Range;
    },
    get Variance() {
        return langMap[ep.resxCulture].Variance || langMap.en.Variance;
    },
    get warning_currency() {
        return langMap[ep.resxCulture].warning_currency || langMap.en.warning_currency;
    },
    get WorkInProgress() {
        return langMap[ep.resxCulture].WorkInProgress || langMap.en.WorkInProgress;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.projectFinancials = projectFinancialsResx;
